import { ValidationMessage, SEVERITY_ERROR } from './ValidationMessage';

export class Error extends ValidationMessage {
    constructor(fieldName, message) {
        super(SEVERITY_ERROR, message, fieldName);
    }
}